import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { X } from 'lucide-react';

const SignaturePad = ({ onSave, onCancel }) => {
  const sigCanvas = useRef(null);

  const clear = () => {
    sigCanvas.current.clear();
  };

  const save = () => {
    if (sigCanvas.current.isEmpty()) {
      alert('Por favor, dibuje su firma');
      return;
    }
    const dataUrl = sigCanvas.current.toDataURL();
    onSave(dataUrl);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="signature-pad-modal">
      <Card className="w-full max-w-lg bg-white p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Firma de Recepción</h3>
          <button onClick={onCancel} className="text-gray-500 hover:text-gray-700">
            <X size={20} />
          </button>
        </div>
        
        <p className="text-sm text-gray-600 mb-4">
          Dibuje su firma con el dedo o el mouse
        </p>
        
        <div className="border-2 border-gray-300 rounded-lg bg-white">
          <SignatureCanvas
            ref={sigCanvas}
            canvasProps={{
              className: 'w-full h-64 touch-none',
              'data-testid': 'signature-canvas'
            }}
            backgroundColor="white"
          />
        </div>
        
        <div className="flex gap-3 mt-4">
          <Button
            variant="outline"
            onClick={clear}
            className="flex-1"
            data-testid="signature-clear-button"
          >
            Limpiar
          </Button>
          <Button
            onClick={save}
            className="flex-1"
            data-testid="signature-save-button"
          >
            Guardar Firma
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SignaturePad;